/**
 * Calcular el máximo de un array de números sin tener en cuenta el 0
 * @param arrayList
 * @returns
 */
export const calculateMax = (arrayList: number[]): number => {
  return arrayList.reduce((value, newValue) =>
    value > newValue && value !== 0 ? value : newValue
  );
};

/**
 * Calcular el mínimo de un array de números sin tener en cuenta el 0
 * @param arrayList
 * @returns
 */
export const calculateMin = (arrayList: number[]): number => {
  return arrayList.reduce((value, newValue) =>
    value < newValue && value !== 0 ? value : newValue
  );
};

/**
 *
 * @param arrayList
 * @returns
 */
export const calculateAlverage = (arrayList: number[]): number => {
  const sum = arrayList.reduce((previous, current) => (current += previous));
  return sum / arrayList.length;
};

/**
 *
 * @param arrayList
 * @returns
 */
export const lowestToHighest = (arrayList: number[]): number[] => {
  return arrayList.sort((a, b) => {
    if (a === b) {
      return 0;
    }
    if (a < b) {
      return -1;
    }
    return 1;
  });
};

/**
 *
 * @param arrayList
 * @returns
 */
export const calculatePercentil = (arrayList: number[]): number => {
  const sortDifference = lowestToHighest(arrayList);
  return sortDifference[Number((sortDifference.length * 0.75).toFixed(0))];
};

export const percentage = (arrayList: number[]) => {
  const count: Record<string, number> = {};

  // 1) Contar apariciones
  arrayList.forEach((n) => {
    count[n] = (count[n] || 0) + 1;
  });

  // 2) Convertir a porcentajes
  const porcentajes: Record<string, string> = {};
  const total = arrayList.length;

  Object.keys(count).forEach((value) => {
    porcentajes[value] = ((count[value] / total) * 100).toFixed(2) + "%";
  });

  return porcentajes;
};
